import React from "react";

const AlertComponent = ({ successMessages, warningMessages, errorMessages, style, onClick }) => {
    return (
        <>
            {successMessages && successMessages.length > 0 && (
                <div className="alert alert-success" style={style} role="alert" onClick={onClick}>
                    {Array.isArray(successMessages) ? (
                        <div>
                            {successMessages.map((item, key) => (
                                <div
                                    key={key}
                                    style={{ whiteSpace: "pre-line" }}
                                    dangerouslySetInnerHTML={{ __html: item }}
                                />
                            ))}
                        </div>
                    ) : (
                        <div
                            style={{ marginTop: "0", marginBottom: "0", whiteSpace: "pre-line" }}
                            dangerouslySetInnerHTML={{ __html: successMessages }}
                        />
                    )}
                </div>
            )}

            {warningMessages && warningMessages.length > 0 && (
                <div className="alert alert-warning" style={style} role="alert" onClick={onClick}>
                    {Array.isArray(warningMessages) ? (
                        <div>
                            {warningMessages.map((item, key) => (
                                <div
                                    key={key}
                                    style={{ whiteSpace: "pre-line" }}
                                    dangerouslySetInnerHTML={{ __html: item }}
                                />
                            ))}
                        </div>
                    ) : (
                        <div
                            style={{ marginTop: "0", marginBottom: "0", whiteSpace: "pre-line" }}
                            dangerouslySetInnerHTML={{ __html: warningMessages }}
                        />
                    )}
                </div>
            )}

            {errorMessages && errorMessages.length > 0 && (
                <div style={style} className="alert alert-danger" role="alert" onClick={onClick}>
                    {Array.isArray(errorMessages) ? (
                        <div>
                            {errorMessages.map((item, key) => (
                                <div
                                    key={key}
                                    style={{ whiteSpace: "pre-line" }}
                                    dangerouslySetInnerHTML={{ __html: item }}
                                />
                            ))}
                        </div>
                    ) : (
                        <div
                            style={{ marginTop: "0", marginBottom: "0", whiteSpace: "pre-line" }}
                            dangerouslySetInnerHTML={{ __html: errorMessages }}
                        />
                    )}
                </div>
            )}
        </>
    );
};

export default AlertComponent;
